(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qx-cart-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__qxCartCroFinalReady) return;
  window.__qxCartCroFinalReady = true;

  const root = () => window.Shopify?.routes?.root || '/';
  const sectionId = 'qx-cart-drawer';

  const replaceDrawer = (html, open = true) => {
    if (!html) return;
    const current = document.getElementById('shopify-section-' + sectionId);
    if (!current) return;

    const temp = document.createElement('div');
    temp.innerHTML = html.trim();
    const incoming = temp.querySelector('#shopify-section-' + sectionId);

    if (incoming) current.replaceWith(incoming);
    else current.innerHTML = html;

    const shell = document.querySelector('[data-qx-cart-shell]');
    if (shell) {
      const count = shell.dataset.cartCount || '0';
      document.querySelectorAll('.qx-cart-count').forEach((element) => {
        element.textContent = count;
      });
      if (open) {
        shell.classList.add('is-open');
        document.body.classList.add('qx-cart-open');
      }
    }
  };

  const cartRequest = async (endpoint, payload) => {
    const response = await fetch(root() + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ...payload,
        sections: sectionId,
        sections_url: location.pathname + location.search
      })
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Cart update failed');
    }

    replaceDrawer(data.sections?.[sectionId], true);
    return data;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-discount-form]');
    if (!form) return;

    event.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-cart-status]');
    const discount = input?.value?.trim() || '';

    if (!discount) {
      if (status) status.textContent = 'Enter a discount code.';
      input?.focus();
      return;
    }

    if (button) button.disabled = true;
    if (status) status.textContent = 'Applying…';

    try {
      await cartRequest('cart/update.js', { discount });
      const nextStatus = document.querySelector('[data-cart-status]');
      if (nextStatus) nextStatus.textContent = 'Discount updated. Applicable savings are shown in the cart.';
    } catch (error) {
      if (status) status.textContent = error.message || 'Unable to apply this discount.';
      if (button) button.disabled = false;
    }
  });

  document.addEventListener('click', async (event) => {
    const removeDiscount = event.target.closest('[data-cart-discount-remove]');
    if (removeDiscount) {
      event.preventDefault();
      removeDiscount.disabled = true;
      try {
        await cartRequest('cart/update.js', { discount: '' });
      } catch (error) {
        
        removeDiscount.disabled = false;
      }
      return;
    }

    const fbtButton = event.target.closest('[data-fbt-add]');
    if (fbtButton) {
      event.preventDefault();
      const shell = fbtButton.closest('[data-qx-cart-shell]');
      const selected = Array.from(shell?.querySelectorAll('[data-fbt-variant]:checked') || [])
        .map((input) => Number(input.value))
        .filter(Boolean);

      if (!selected.length) return;

      fbtButton.disabled = true;
      fbtButton.textContent = 'Adding…';

      try {
        await cartRequest('cart/add.js', {
          items: selected.map((id) => ({ id, quantity: 1 }))
        });
      } catch (error) {
        
        fbtButton.disabled = false;
        fbtButton.textContent = 'Add selected items';
      }
    }
  });

  let noteTimer;
  document.addEventListener('input', (event) => {
    const note = event.target.closest('[data-cart-note]');
    if (!note) return;

    clearTimeout(noteTimer);
    const scope = note.closest('[data-qx-cart-shell]');
    const status = scope?.querySelector('[data-cart-note-status]');
    if (status) status.textContent = 'Saving…';

    noteTimer = setTimeout(async () => {
      try {
        await cartRequest('cart/update.js', { note: note.value });
        const nextStatus = document.querySelector('[data-cart-note-status]');
        if (nextStatus) nextStatus.textContent = 'Saved';
      } catch (error) {
        if (status) status.textContent = 'Could not save note';
      }
    }, 650);
  });

  let giftMessageTimer;
  document.addEventListener('input', (event) => {
    const field = event.target.closest('[data-cart-gift-message]');
    if (!field) return;

    clearTimeout(giftMessageTimer);
    const scope = field.closest('[data-qx-cart-shell]');
    const status = scope?.querySelector('[data-cart-gift-status]');
    if (status) status.textContent = 'Saving…';

    giftMessageTimer = setTimeout(async () => {
      try {
        await cartRequest('cart/update.js', {
          attributes: { 'Gift message': field.value }
        });
        const nextStatus = document.querySelector('[data-cart-gift-status]');
        if (nextStatus) nextStatus.textContent = 'Saved';
      } catch (error) {
        if (status) status.textContent = 'Could not save gift message';
      }
    }, 650);
  });

  const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-shipping-estimator]');
    if (!form) return;

    event.preventDefault();

    const shell = form.closest('[data-qx-cart-shell]');
    const status = shell?.querySelector('[data-shipping-status]');
    const ratesTarget = shell?.querySelector('[data-shipping-rates]');
    const button = form.querySelector('button[type="submit"]');

    const country = form.elements.country?.value?.trim() || '';
    const province = form.elements.province?.value?.trim() || '';
    const zip = form.elements.zip?.value?.trim() || '';

    if (!country || !zip) {
      if (status) status.textContent = 'Enter a country and ZIP / postal code.';
      return;
    }

    const params = new URLSearchParams();
    params.set('shipping_address[country]', country);
    params.set('shipping_address[zip]', zip);
    if (province) params.set('shipping_address[province]', province);

    if (button) button.disabled = true;
    if (status) status.textContent = 'Calculating estimated shipping rates…';
    if (ratesTarget) ratesTarget.innerHTML = '';

    try {
      const prepare = await fetch(root() + 'cart/prepare_shipping_rates.json?' + params.toString(), {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });

      if (!prepare.ok && prepare.status !== 202) {
        throw new Error('Unable to prepare shipping rates.');
      }

      let payload = null;

      for (let attempt = 0; attempt < 7; attempt += 1) {
        await wait(attempt === 0 ? 250 : 650);

        const response = await fetch(root() + 'cart/async_shipping_rates.json?' + params.toString(), {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.error?.[0] || errorData.message || 'Unable to calculate shipping rates.');
        }

        payload = await response.json();

        if (payload && Array.isArray(payload.shipping_rates)) break;
      }

      const rates = payload?.shipping_rates || [];

      if (!rates.length) {
        if (status) status.textContent = 'No shipping rates were returned for this destination. Checkout will show final options.';
        return;
      }

      if (status) status.textContent = `${rates.length} estimated shipping option${rates.length === 1 ? '' : 's'} found.`;

      if (ratesTarget) {
        ratesTarget.innerHTML = '';

        rates.forEach(rate => {
          const row = document.createElement('div');
          row.className = 'qx-cart-shipping-rate';

          const name = document.createElement('span');
          name.textContent = rate.presentment_name || rate.name || 'Shipping';

          const price = document.createElement('strong');
          price.textContent = rate.price ? `${rate.price} ${shell?.dataset.cartCurrency || ''}`.trim() : '';

          row.append(name, price);
          ratesTarget.appendChild(row);
        });
      }
    } catch (error) {
      if (status) status.textContent = error.message || 'Unable to calculate shipping rates.';
    } finally {
      if (button) button.disabled = false;
    }
  });


  document.addEventListener('submit', (event) => {
    const cartForm = event.target.closest('[data-cart-form]');
    const checkout = event.submitter?.matches?.('[data-cart-checkout]') ? event.submitter : cartForm?.querySelector('[data-cart-checkout]');
    if (!cartForm || !checkout || event.submitter?.name !== 'checkout') return;
    if (checkout.dataset.submitting === 'true') { event.preventDefault(); return; }
    checkout.dataset.submitting = 'true'; checkout.disabled = true; checkout.classList.add('is-loading');
    const status = cartForm.querySelector('[data-cart-checkout-status]'); if (status) status.textContent = 'Opening secure checkout…';
  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qx-collection-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'qxCollectionGridDensity';
  const allowed = ['2', '3', '4', '5', '6'];

  const init = (root) => {
    if (!root || root.dataset.collectionControllerReady === 'true') return;
    root.dataset.collectionControllerReady = 'true';

    const grid = root.querySelector('[data-collection-grid]');
    const buttons = Array.from(root.querySelectorAll('[data-grid-density]'));
    const fallback = allowed.includes(root.dataset.defaultGrid) ? root.dataset.defaultGrid : '4';
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    if (grid && buttons.length) {
      const applyDensity = (value, persist) => {
        const density = allowed.includes(String(value)) ? String(value) : fallback;
        if (desktopQuery.matches) grid.style.setProperty('--qx-grid-density', density);
        else grid.style.removeProperty('--qx-grid-density');

        buttons.forEach((button) => {
          const active = desktopQuery.matches && button.dataset.gridDensity === density;
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (persist) {
          try { localStorage.setItem(storageKey, density); } catch (error) {}
        }
      };

      let saved = null;
      try { saved = localStorage.getItem(storageKey); } catch (error) {}
      const syncDensity = () => applyDensity(saved || fallback, false);
      syncDensity();

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          saved = button.dataset.gridDensity;
          applyDensity(saved, true);
        });
      });

      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', syncDensity);
      else if (desktopQuery.addListener) desktopQuery.addListener(syncDensity);
    }

    const scrollKey = 'qxCollectionScroll:' + location.pathname;
    root.addEventListener('click', (event) => {
      if (!event.target.closest('.qx-product-card a')) return;
      try { sessionStorage.setItem(scrollKey, String(window.scrollY)); } catch (error) {}
    });
  };

  const boot = (scope) => {
    if (scope?.matches?.('[data-collection-root]')) init(scope);
    scope?.querySelectorAll?.('[data-collection-root]').forEach(init);
  };

  boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  window.addEventListener('pageshow', () => {
    const key = 'qxCollectionScroll:' + location.pathname;
    try {
      const saved = sessionStorage.getItem(key);
      if (!saved) return;
      requestAnimationFrame(() => window.scrollTo({ top: Number(saved), behavior: 'auto' }));
      sessionStorage.removeItem(key);
    } catch (error) {}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qx-product-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  const parseVariants = (root) => {
    try { return JSON.parse(root.querySelector('[data-qx-variant-data]')?.textContent || '[]'); }
    catch (error) { return []; }
  };

  const formatMoney = (root, cents) => {
    const amount = (Number(cents) || 0) / 100;
    const money = root.dataset.moneyFormat || '{{amount}}';
    try {
      let out = money;
      out = out.replace(/{{s*amount_no_decimalss*}}/g, Math.round(amount).toLocaleString());
      out = out.replace(/{{s*amounts*}}/g, amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      return out;
    } catch (error) {
      return amount.toFixed(2);
    }
  };

  const init = (root) => {
    if (!root || root.dataset.productControllerReady === 'true') return;
    root.dataset.productControllerReady = 'true';

    const variants = parseVariants(root);
    const variantInput = root.querySelector('[data-variant-id]');
    const currentVariant = () => variants.find((variant) => String(variant.id) === String(variantInput?.value)) || variants[0] || null;

    const share = root.querySelector('[data-qx-pdp-share]');
    share?.addEventListener('click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, text: root.dataset.productTitle || document.title, url: location.href });
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(location.href);
        }
      } catch (error) {}
    });

    root.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-pickup-open]');
      if (!opener) return;
      const dialog = document.getElementById(opener.dataset.pickupOpen);
      if (dialog?.showModal) dialog.showModal();
    });

    const input = root.querySelector('[data-qx-quantity-input]');
    const cards = Array.from(root.querySelectorAll('[data-qx-quantity-choice]'));
    if (input && cards.length) {
      const paint = () => {
        const qty = Math.max(1, parseInt(input.value || '1', 10));
        const variant = currentVariant();
        cards.forEach((card) => {
          const n = parseInt(card.dataset.qxQuantityChoice, 10);
          const selected = n === qty;
          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-pressed', selected ? 'true' : 'false');
          const total = card.querySelector('[data-qx-quantity-total]');
          if (total && variant) total.textContent = formatMoney(root, variant.price * n);
          const unit = card.querySelector('[data-qx-unit-price]');
          if (unit && variant) unit.textContent = formatMoney(root, variant.price);
        });
      };

      cards.forEach((card) => card.addEventListener('click', () => {
        input.value = card.dataset.qxQuantityChoice;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        paint();
      }));

      input.addEventListener('input', paint);
      input.addEventListener('change', paint);
      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-qty-minus],[data-qty-plus]')) requestAnimationFrame(paint);
      });
      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-product-option],select,input[type="radio"]')) {
          requestAnimationFrame(() => requestAnimationFrame(paint));
        }
      });
      if (variantInput) {
        new MutationObserver(paint).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        variantInput.addEventListener('change', paint);
      }
      paint();
    }

    const box = root.querySelector('[data-qx-selling-plans]');
    if (box) {
      const hidden = box.querySelector('[data-qx-selling-plan-input]');
      const currency = root.dataset.currency || 'USD';

      const sync = () => {
        const variant = currentVariant();
        if (!variant) return;
        const allocations = variant.selling_plans || [];

        box.querySelectorAll('[data-selling-plan-id]').forEach((label) => {
          const allocation = allocations.find((item) => String(item.id) === String(label.dataset.sellingPlanId));
          label.hidden = !allocation;
          if (allocation) {
            const price = label.querySelector('small');
            if (price) {
              price.textContent = (Number(allocation.price) / 100).toLocaleString(undefined, { style: 'currency', currency });
            }
          }
        });

        const checked = box.querySelector('[data-qx-purchase-option]:checked');
        if (checked && checked.value !== 'one_time' && !allocations.some((item) => String(item.id) === String(checked.value))) {
          const fallback = box.querySelector('[data-qx-purchase-option][value="one_time"]') || box.querySelector('[data-selling-plan-id]:not([hidden]) [data-qx-purchase-option]');
          if (fallback) {
            fallback.checked = true;
            fallback.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };

      box.addEventListener('change', (event) => {
        const radio = event.target.closest('[data-qx-purchase-option]');
        if (!radio) return;
        box.querySelectorAll('.qx-pdp__purchase-option').forEach((item) => item.classList.toggle('is-selected', item.contains(radio)));
        if (hidden) hidden.value = radio.value === 'one_time' ? '' : radio.value;
      });

      if (variantInput) {
        variantInput.addEventListener('change', sync);
        new MutationObserver(sync).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
      sync();
    }
  };

  const boot = (scope) => {
    if (scope?.matches?.('[data-product-root]')) init(scope);
    scope?.querySelectorAll?.('[data-product-root]').forEach(init);
  };

  boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
